(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-bundle-template"]) return;
  try {
    
jQuery( document ).ready(function() {
    jQuery('[data-shopify="payment-button"]').remove();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_bbp_boxed_small"]) return;
  try {
    
jQuery( document ).ready(function() {
    jQuery('[data-shopify="payment-button"]').remove();
});


  } catch(e) { console.error(e); }
})();
})();
